import {FC, memo} from "react";
import {Container, Heading} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {

}

export const NotFound: FC<Props> = memo((props) => {
    const {t} = useTranslation();
    return (
        <Container pt="5">
            <Heading size="xl">{t("notfound.message")}</Heading>
        </Container>
    );
});